module.exports = __webpack_public_path__ + "img/81w.ca8c14b.jpg";